import CommonService from "@/services/common/commonServices";
import uitext from "@/uitext.json";
import {
  DEFAULT_LANG_ID,
  langLocale,
  localStorageKey,
} from "@/utils/constants";
import { showErrorAPI } from "@/services/apiRoutes";
import { Route } from "@/services/apiRoutes/routes";
import dayjs from "dayjs";
import Utils from "@/utils/utilities";
import { load } from "recaptcha-v3";

export default {
  namespaced: true,

  state() {
    return {
      languagesData: [],
      languageList: [],
      languageSelected: DEFAULT_LANG_ID,
      languageSelectedText: "",
      defaultUiText: [],
      pwdFeIv: "",
    };
  },

  getters: {},
  mutations: {
    initialiseStore: (state: any) => {
      state.defaultUiText = uitext;
      if (localStorage.getItem(localStorageKey.languageId)) {
        state.languageSelected = localStorage.getItem(
          localStorageKey.languageId,
        );
      }
      if (localStorage.getItem(localStorageKey.languagesData)) {
        state.languagesData = Object.assign(
          {},
          JSON.parse(
            localStorage.getItem(localStorageKey.languagesData) as any,
          ),
        );
        const result = Object.values(state.languagesData).filter(
          (element: any) => state.languageSelected === element.id.toLowerCase(),
        )[0];
        if (result) {
          state.languageSelectedText = (result as any).ui_text;
        }
      }
      if (localStorage.getItem(localStorageKey.languageList)) {
        state.languageList = JSON.parse(
          localStorage.getItem(localStorageKey.languageList) as any,
        );
      }
    },
    SET_LANG_DATA: (state: any, list: any) => {
      const langId =
        localStorage.getItem(localStorageKey.languageId) || DEFAULT_LANG_ID;
      const languages = list.find((element: any) => element.id === langId);
      localStorage.setItem(
        localStorageKey.languagesData,
        JSON.stringify(Object.assign({}, [languages])),
      );
      state.languagesData = Object.assign({}, [languages]);
    },
    SET_LANG_LIST_DATA: (state: any, list: any) => {
      localStorage.setItem(
        localStorageKey.languageList,
        JSON.stringify(Object.assign({}, list)),
      );
      state.languageList = Object.assign({}, list);
    },
    SET_LANG_SELECTED: (state: any, lang: string) => {
      dayjs.locale(langLocale[lang]);
      localStorage.setItem(localStorageKey.languageId, lang);
      state.languageSelected = lang;
    },
    SET_LANG_SELECTED_DATA: (state: any) => {
      const result = Object.values(state.languagesData).filter(
        (element: any) => state.languageSelected === element.id.toLowerCase(),
      )[0];
      if (result) {
        state.languageSelectedText = (result as any).ui_text;
      }
    },
    SET_PASSWORD_FE_IV_DATA: (state, payload) => {
      state.pwdFeIv = payload;
    },
  },
  actions: {
    setLanguages: async ({ commit }: { commit: any }) => {
      const commonServices = new CommonService();
      const recaptchaToken = await refreshRecaptchaToken();

      try {
        await fetchAndSetLanguagesData(recaptchaToken);
      } catch (error: any) {
        showErrorAPI(error, Route.uiText);
      }

      // Function to fetch and set languages data
      async function fetchAndSetLanguagesData(token: string) {
        const response: any = await commonServices.getLanguagesData(token);
        const { languages, pwdFeIv } = response.data.data;
        const formattedLanguages = languages.map((lang: any) => {
          const formattedUIText = lang.ui_text.map(
            (item: { id: string; text: string }) => {
              item.id = item.id.toLowerCase();
              return item;
            },
          );
          lang.ui_text = formattedUIText;
          return lang;
        });
        localStorage.setItem(localStorageKey.pwdFeIv, `${pwdFeIv}`);
        commit("SET_LANG_DATA", formattedLanguages);
        commit("SET_LANG_SELECTED_DATA");
        commit("SET_PASSWORD_FE_IV_DATA", pwdFeIv);
      }

      // Function to refresh the reCAPTCHA token
      async function refreshRecaptchaToken() {
        const finalKey = await Utils.getV3Recaptcha();
        const recaptcha = await load(`${finalKey}`, {
          autoHideBadge: true,
        });
        const token = await recaptcha.execute("submit");
        localStorage.setItem(localStorageKey.recaptcha, token);
        return token;
      }
    },
    setLanguageList: ({ commit }: { commit: any }, token: any) => {
      const commonServices = new CommonService();
      return new Promise((resolve, reject) => {
        commonServices.getLanguages(token).then(
          (response: any) => {
            commit("SET_LANG_LIST_DATA", response.data.data);
            resolve(response);
          },
          (error: any) => {
            showErrorAPI(error, Route.languages);

            reject(error);
          },
        );
      });
    },
    setSelectedLanguage: async ({ commit }: { commit: any }, lang: string) => {
      await commit("SET_LANG_SELECTED", lang);
      await commit("SET_LANG_SELECTED_DATA");
    },
  },
};
